import { api } from '../api';

export const getDocumentsAsync = async () => {
  let url = '/document';
  const response = await api.get(url)
  return response.data ? response.data : [];
}

export const getDocumentAsync = async (documentId) => {
  let url = `/document/${documentId}`;
  let response = await api.get(url);
  return (response.data.customer ? response.data.customer : []);

}

export const createDocumentAsync = async (data) => {
  let url = `/document/`;
  let response = await api.post(url,data);
  return (response.status ===200 ? true : false);

}

export const deleteDocumentAsync = async (documentId) => {
  let url = `/document/${documentId}`;
  let response = await api.delete(url);
  return (response.status ===200 ? true : false);

}

export const updateDocumentAsync = async (documentId, data) => {
  let deleted = await deleteDocumentAsync(documentId);
  let result = false;
  if (deleted) {
    result = await createDocumentAsync(data);
  }
  
  return (result ? true : false);

}